var chunkMapping = {
	"9": [
		5009
	],
	"209": [
		6209
	],
	"442": [
		2442
	],
	"507": [
		2369
	],
	"807": [
		807
	]
};
var idToExternalAndNameMapping = {
	"807": [
		"default",
		"./AccessControlApp",
		3494
	],
	"2369": [
		"default",
		"./App",
		3370
	],
	"2442": [
		"default",
		"./App",
		1108
	],
	"5009": [
		"default",
		"./App",
		3772
	],
	"6209": [
		"default",
		"./App",
		1786
	]
};
var idToRemoteMap = {
	"807": [
		{
			"externalType": "script",
			"name": "access_control",
			"externalModuleId": 3494
		}
	],
	"2369": [
		{
			"externalType": "script",
			"name": "khq_service_ui_mfe",
			"externalModuleId": 3370
		}
	],
	"2442": [
		{
			"externalType": "script",
			"name": "khq_drop_ui_mfe",
			"externalModuleId": 1108
		}
	],
	"5009": [
		{
			"externalType": "script",
			"name": "khq_reporting_ui_mfe",
			"externalModuleId": 3772
		}
	],
	"6209": [
		{
			"externalType": "script",
			"name": "broadcast_ui",
			"externalModuleId": 1786
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}